import React, { useState } from 'react';
import './Investments.css'; // Styling specific to investments

const InvestmentModal = ({ investment, onClose }) => {
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleImageClick = (imgSrc) => {
    setEnlargedImage(imgSrc);
  };

  const handleCloseEnlargedImage = () => {
    setEnlargedImage(null);
  };

  if (!investment) return null;

  const {
    title = 'No Title',
    description = 'No description available.',
    mainImage: rawMainImage = '/default-image.png',
    additionalImages: rawAdditionalImages = [],
    tags = [],
    specification = 'No specification available.',
  } = investment;

  const prefixedMainImage = rawMainImage.startsWith('http')
    ? rawMainImage
    : `https://apiqms.shigjeta.com${rawMainImage}`;

  const prefixedAdditionalImages = rawAdditionalImages.map((img) => ({
    src: img.src.startsWith('http') ? img.src : `https://apiqms.shigjeta.com${img.src}`,
    alt: img.alt || title,
  }));

  return (
    <>
      {/* Modal Overlay */}
      <div className="modal-overlay show" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-btn" onClick={onClose}>
            &times;
          </button>

          {/* Images */}
          <div className="modal-images">
            <img
              src={prefixedMainImage}
              alt={title}
              className="main-image"
              onClick={() => handleImageClick(prefixedMainImage)}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://apiqms.shigjeta.com/default-image.png';
                console.error(`Modal: Failed to load main image for ${title}: ${rawMainImage}`);
              }}
            />

            {prefixedAdditionalImages.length > 0 && (
              <div className="additional-images">
                {prefixedAdditionalImages.map((img, index) => (
                  <img
                    key={index}
                    src={img.src}
                    alt={img.alt}
                    onClick={() => handleImageClick(img.src)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://apiqms.shigjeta.com/default-image.png';
                      console.error(`Modal: Failed to load additional image ${index + 1} for ${title}`);
                    }}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Investment Info */}
          <div className="modal-info">
            <div className="modal-header">
              <h2>{title}</h2>
            </div>

            <div className="modal-description">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </div>

            <div className="modal-specification">
              <h3>Key Specifications:</h3>
              <div dangerouslySetInnerHTML={{ __html: specification }} />
            </div>

            {tags.length > 0 && (
              <div className="modal-tags">
                <h3>Tags:</h3>
                <ul>
                  {tags.map((tag, index) => (
                    <li key={index}>{tag}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Enlarged Image */}
      {enlargedImage && (
        <div className="enlarged-image-container">
          <div className="enlarged-image-content">
            <img src={enlargedImage} alt="Enlarged View" className="enlarged-image" />
            <button className="enlarged-image-close-btn" onClick={handleCloseEnlargedImage}>
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InvestmentModal;
